import React, { useContext, useEffect, useState, useMemo } from "react";
import ReactDOM from "react";

import CardBase from "../../cards/CardBase";

import ReactECharts from 'echarts-for-react';
import ListDataTable from '../ListDataTable'


type ChartDataProp = {
    name: string
    value: number
}

type JSONDataProp = {
    JSONData: string
}
type JSONDataValueProp = {
    Title: string
    Lbl: string
}

type ListDataValueProp = {
    ListTitle: string
    ListData: object
}

type EChartEventParamsProp = {
    componentType: string
    // 系列类型。值可能为：'line'、'bar'、'pie' 等。当 componentType 为 'series' 时有意义。
    seriesType: string
    // 系列在传入的 option.series 中的 index。当 componentType 为 'series' 时有意义。
    seriesIndex: number
    // 系列名称。当 componentType 为 'series' 时有意义。
    seriesName: string
    // 数据名，类目名
    name: string
    // 数据在传入的 data 数组中的 index
    dataIndex: number
    // 传入的原始数据项
    data: Object
    // sankey、graph 等图表同时含有 nodeData 和 edgeData 两种 data，
    // dataType 的值会是 'node' 或者 'edge'，表示当前点击在 node 还是 edge 上。
    // 其他大部分图表中只有一种 data，dataType 无意义。
    dataType: string
    // 传入的数据值
    value: number | []
    // 数据图形的颜色。当 componentType 为 'series' 时有意义。
    color: string
}


type ChatTypeObject= {
    Type:string
    Ord:string
}

import { HibModal } from '../../HibModal'

//全部圖表

export default (props: { data: MixChart.CardDataProp }) => {

    //console.log("render")
    const [index, setIndex] = useState<number>(0)
    const jDatas: [] = JSON.parse(props.data.JSONData) as []
    const cdps: { chartData: string }[] = JSON.parse(props.data.ChartData) as { chartData: string }[]
    const [LData, setLData] = useState<ListDataValueProp | null>()
    
    let lds: { ListData: string }[] = []

    if (props.data.ListData) {
        lds = JSON.parse(props.data.ListData) as { ListData: string }[]
    }

    const renderTitle = (): string => {
        const _d: string = (jDatas[index] as JSONDataProp).JSONData
        const jData: JSONDataValueProp = JSON.parse(_d)[0]
        return jData.Title + "：" + jData.Lbl

    }

    const renderChartData = (): ChartDataProp[] => {
        const str: string = cdps[index].chartData
        return JSON.parse(str) as ChartDataProp[]
    }


    const renderBarTitle = (): string[] => {
        const ary: string[] = []
        const _d: ChartDataProp[] = renderChartData()
        _d.map((item: ChartDataProp) => {
            ary.push(item.name)
        })
        
        return ary
    }

    const renderBarData = (): number[] => {
        const ary: number[] = []
        const _d: ChartDataProp[] = renderChartData()

        _d.map((item: ChartDataProp) => {
            ary.push(item.value)
        })
        return ary
    }

    const onEvents = {
        click: (params: EChartEventParamsProp) => {
            if (lds.length > 0) {
                const ldvp = JSON.parse(lds[index].ListData)[0] as ListDataValueProp
                setLData(ldvp)
            }

        },
    };
    
    return (
        <CardBase
            collapseDisabled={true}
            collapseControl={true}
            title={
                props.data.ChartTitle + " - " + renderTitle()
            }
            type="MixChart"
            children={
                <div>
                    <div style={{ margin: "10px 0", textAlign: "right" }}>
                        {

                            jDatas.length <= 3 ?
                                jDatas.map((item: JSONDataProp, index: number) => {
                                    const _d: string = (item as JSONDataProp).JSONData
                                    const jData: JSONDataValueProp = JSON.parse(_d)[0]
                                    return (
                                        <button
                                            key={jData.Title + "_" + index}
                                            className="hibBtn main small"
                                            onClick={() => {
                                                setIndex(index)
                                            }}
                                        >
                                            {
                                                jData.Title
                                            }
                                        </button>
                                    )
                                })
                                :
                                <select
                                    className="hibSelect"
                                    onChange={(event: React.ChangeEvent<HTMLSelectElement>) => {
                                        setIndex(parseInt(event.target.value))
                                    }}
                                >
                                    {
                                        jDatas.map((item: JSONDataProp, index: number) => {
                                            const _d: string = (item as JSONDataProp).JSONData
                                            const jData: JSONDataValueProp = JSON.parse(_d)[0]
                                            return (
                                                <option
                                                    key={jData.Title + "_" + index}
                                                    value={index}
                                                >
                                                    {
                                                        jData.Title
                                                    }
                                                </option>
                                            )
                                        })
                                    }
                                </select>
                        }
                    </div>
                    {

                        (
                            JSON.parse(props.data.Type) as ChatTypeObject[]).map((item: ChatTypeObject) => {

                            //這邊的item要建類別
                            return (
                                <>
                                    {
                                        item.Type == "Pie01" ?
                                            <ReactECharts
                                                onEvents={onEvents}
                                                option={{
                                                    textStyle: {
                                                        fontSize: '16',
                                                    },
                                                    series: [
                                                        {
                                                            name: 'Access From',
                                                            type: 'pie',
                                                            radius: '50%',
                                                            data: renderChartData(),
                                                            emphasis: {
                                                                itemStyle: {
                                                                    shadowBlur: 10,
                                                                    shadowOffsetX: 0,
                                                                    shadowColor: 'rgba(0, 0, 0, 0.5)'
                                                                }
                                                            }
                                                        }
                                                    ]
                                                }}
                                            /> :
                                            item.Type == "Bar01" ?
                                                <ReactECharts
                                                    style={{
                                                        height: (
                                                            40 * renderBarData().length > 300 ?
                                                                40 * renderBarData().length :
                                                                300
                                                        )
                                                    }}
                                                    onEvents={onEvents}
                                                    option={{
                                                        tooltip: {
                                                            trigger: 'axis',
                                                            axisPointer: {
                                                                type: 'shadow'
                                                            }
                                                        },
                                                        legend: {},
                                                        xAxis: {
                                                            type: 'value',
                                                            boundaryGap: [0, 0.01]
                                                        },
                                                        yAxis: {
                                                            type: 'category',
                                                            data: renderBarTitle(),
                                                            axisLine: { show: false }, axisLabel: { show: false },
                                                            axisTick: { show: false },
                                                            splitLine: { show: false },
                                                            inverse: item.Ord == "asc" ? true : false //bar的排序
                                                        },
                                                        series: [
                                                            {
                                                                type: 'bar',
                                                                label: {
                                                                    show: true,
                                                                    formatter: '{b}',
                                                                    color: "#000",
                                                                    position: "insideLeft",
                                                                    verticalAlign: "middle",
                                                                    fontSize: 16,
                                                                },
                                                                itemStyle: {
                                                                    color: "#0cf"
                                                                },
                                                                data: renderBarData()
                                                            }
                                                        ]
                                                    }
                                                    }
                                                />
                                                : ""
                                    }
                                </>
                            )

                        })

                    }
                    <HibModal
                        title={LData?.ListTitle}
                        show={LData ? true : false}
                        type="fit"
                        cancel={() => { setLData(null) }}
                        children={
                            <>
                                {
                                    LData &&
                                    LData.ListData &&
                                    <ListDataTable dataStr={LData.ListData} />
                                }
                            </>
                        }
                    />

                </div>

            }
        />
    )
}